import { useEffect, useMemo, useState } from 'react';

import hero1 from '../../assets/hero/hero-1.svg';
import hero2 from '../../assets/hero/hero-2.svg';
import hero3 from '../../assets/hero/hero-3.svg';

const DEFAULT_INTERVAL_MS = 8000;

function prefersReducedMotion() {
  if (typeof window === 'undefined') return false;
  return window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ?? false;
}

export default function HeroBackgroundRotator({ intervalMs = DEFAULT_INTERVAL_MS }) {
  const images = useMemo(() => [hero1, hero2, hero3], []);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    // Preload so first crossfade is smooth.
    images.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, [images]);

  useEffect(() => {
    if (prefersReducedMotion()) return undefined;

    const id = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, Math.max(2000, intervalMs));

    return () => window.clearInterval(id);
  }, [images.length, intervalMs]);

  const prevIndex = (index - 1 + images.length) % images.length;

  return (
    <div className="splash-bg-rotator" aria-hidden="true">
      <div
        className="splash-bg-layer"
        style={{ backgroundImage: `url(${images[prevIndex]})` }}
      />
      <div
        className="splash-bg-layer is-active"
        style={{ backgroundImage: `url(${images[index]})` }}
      />
      <div className="splash-bg-overlay" />
    </div>
  );
}

